export default class DesignEditorLoader {
  private _template = `
  <style>
    .loader-border {
      display: block;
      width: 62px;
      height: 62px;
      position: absolute;
      top: 0;
      left: 0;
      border: 5px solid;
      border-radius: 50px;
      transition: all 0.2s;
      animation: infinity-circle-scale 0.7s infinite linear;
    }
    
    @keyframes infinity-circle-scale {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.4);
      }
      100% {
        transform: scale(1);
      }
    }
  </style>
  <div class="loader-border"></div>
  `;
  private _loader: HTMLDivElement | null = null;

  constructor() {}

  setup() {
    const editorElement = document.querySelector('au-editor');
    if (editorElement && editorElement.shadowRoot) {
      this._loader = editorElement.shadowRoot.querySelector('.loader-wraper > .loader');
    }
  }

  addTemplate() {
    if (this._loader) {
      this._loader.innerHTML = this._template;
    }
  }
}